export function getSurveyLinkID(id: string) {
  return `${id}${btoa(id.slice(8) + id.slice(0, 8)).slice(0, 8)}`;
}
